<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Platforma IMM Recover"></SketchBreadcrumb>
        <div class="padding-box flex columnMobile space-between">
            <div class="mysmis white-box">
                <h4>Platforma IMM Recover</h4>
                <p class="mb-4">Apelul de proiecte pentru “Investiții în activități productive” este unul competitiv, cu depunere continuă până la data închiderii apelulului.</p>

                <p class="mb-4">Cererile de finanţare se vor depune prin platforma IMM Recover , cu toate anexele solicitate prin Ghidul Solicitantului. </p>

                <a href="https://granturi.imm.gov.ro/" target="_blank" class="gov-link">
                    <img src="@/assets/images/M3/M3Sketch/gov-logo.png" class="">
                    <div class="blue-button-background">Creează cont sau autentifică-te în platforma IMM Recover</div>
                </a>


                <p class="mt-4 mb-4">Înainte de demararea completării conţinutului Cererii de finanţare, solicitanţii au obligaţia înregistrării în sistem, conform indicaţiilor din tutorialul alăturat. Odată cu înregistrarea solicitantului, este necesară completarea tuturor câmpurilor, întrucât informaţiile din aceaste secţiuni sunt esenţiale pentru verificarea eligibilităţii solicitantului sau pentru evaluarea tehnico-economică.</p>

                <p>Vă rugăm să citiți cu atenție ghidul solicitantului și să respectați cu strictețe prevederile acestuia.</p>

                <a href="https://mfe.gov.ro/poc-ghidul-consolidat-aferent-actiunii-4-1-1-investitii-in-activitati-productive/" target="_blank" class="gov-link mt-5 mb-4">
                    <img src="@/assets/images/M3/M3Sketch/folder-download.png" class="">
                    <div class="gray-button-background">Descarcă ghidul solicitantului, Anexe și Documente suport</div>
                </a>
            </div>
            <div class="deschiderea-proiectului white-box">
                <div class="title">Crearea contului în platforma IMM Recover</div>
                <iframe width="450" height="450" src="https://www.youtube.com/embed/hkMk_GZscQE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <div class="flex space-between align-center">
                    <b-form-checkbox
                        v-model="tutorial1"
                        switch
                        size="lg"
                        class="switch-box"
                        @change="completeTutorial()"
                    >Am creat contul</b-form-checkbox>
                    <M3Warn
                        class="warn-flex"
                        type="blue"
                        :text="'<strong>Atenție!</strong> Vei observa acest buton în fiecare pagină. Informațiile vor fi salvate exclusiv după activarea butonului (salvare/verde). În cazul în care ai blocat secțiunea este necesar să o deblochezi înainte de a edita alte informații. Îți mulțumim!'"
                    ></M3Warn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BFormCheckbox, BIconDownload, BFormInput} from 'bootstrap-vue'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'

    export default {
        components: {
            M3Warn,
            SketchBreadcrumb,
            BFormCheckbox,
            BIconDownload,
            BFormInput,
        },
        data() {
            return {
                tutorial1: false,
                section: {
                    section: 'imm-recover'
                }
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            checks: {
                handler: function() {
                    this.tutorial1 = this.checks.immAccount;

                    if(this.tutorial1){
                        this.$store.dispatch('pages/addPage', this.section);
                    } else{
                        this.$store.dispatch('pages/removePage', this.section);
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        },
        methods: {
            completeTutorial() {

                this.$store.dispatch('checks/updateChecks', {name: 'immAccount', value: this.tutorial1});

                if(this.tutorial1){
                    this.formSend = {
                        is_imm_account_added: this.tutorial1
                    }
                    this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                        .then((response) => {
                            this.$toast.success(response.data);
                        })
                }
            },
        }
    }
</script>

<style scoped>
.mysmis h4{
    font-size: 15px;
    font-weight: 500;
    text-align: left;
    text-indent: 0;
    margin-bottom: 40px;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
    height: fit-content;
}
.mysmis{
    width: 100%;
    max-width: 600px;
    text-align: center;
    height: fit-content;
    min-height: 660px;
}
.error-input{
    border-color: red !important;
}
.gov-link{
    display: flex;
    align-items: center;
}
.gov-link:hover{
    text-decoration: none;
}
.gov-link img{
    margin-right: 15px;
}
.switch-box{
    margin-left: 0 !important;
    cursor: pointer;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.warn-flex{
    max-width: 540px;
}
.blue-button-background{
    background: #004990;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    padding: 10px;
    border-radius: 7px;
    border: 1px solid #fff;
    max-height: 30px;
}
.gray-button-background{
    background: #545a6f;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    padding: 10px;
    border-radius: 7px;
    border: 1px solid #fff;
    max-height: 30px;
}
.mysmis p{
    font-size: 12px;
    font-weight: 500;
    color: #5b6276;
}
.mysmis span{
    color: #9a9da7;
    font-size: 12px;
    font-weight: 500;
}
.mysmis span a{
    color: inherit;
}
.tutoriale{
    width: 100%;
    height: 100%;
}
.tutorial{
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}
.manuale{
    display: flex;
    flex-direction: column;
    margin-top: 30px;
}
 .title{
    color: #5b6276;
    font-size: 14px;
    font-weight: 600;
}
.manual{
    display: flex;
    text-decoration: none;
    margin-bottom: 15px;
    align-items: center;
}
.manuale p{
    font-size: 12px;
    color: #5b6276;
    font-weight: 500;
}
.switch-box{
    margin-left: 20px;
}
.deschiderea-proiectului{
    width: 100%;
    height: fit-content;
}
.deschiderea-proiectului iframe{
    width: 100%;
    margin-top: 20px;
    max-height: 450px;
}
.deschiderea-proiectului p{
    font-size: 12px;
    font-weight: 500;
    color: #5b6276;
}
.red{
    color: #ff5050;
    font-weight: 800;
    font-size: 16px;
}
input{
    border-radius: 0;
    font-size: 13px;
    margin: 5px 0;
    color: #9da2b3;
    text-align: center;
}
input:focus{
    color: #9da2b3;
}
.cod-input{
    font-size: 27px;
    letter-spacing: 6px;
}
.blue-button{
    cursor: pointer;
    margin-top: 20px;
    font-size: 12px;
    background: #01e8c6;
    color: #5b6276;
    max-width: 180px;
    padding: 4px 0;
    text-align: center;
    width: 100%;
}
.blue-button:hover{
    color: #fff;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
@media (max-width: 1800px){
    .columnMobile{
        flex-direction: column;
    }
    .mysmis, .deschiderea-proiectului{
        width: 100%;
        max-width: 100%;
        min-height: inherit;
        margin-bottom: 15px;
    }
}
</style>
